<div>
  <button style="visibility: hidden;" id="dynoshow"></button>
  <a *ngFor="let attachment of Attachments; let i=index" (click)="onClick(attachment,i)" [class]="isPublic(attachment)"><img src="/assets/icons/oxygen/22x22/mimetypes/application-pdf.png"/><span class="bgca-brand">{{attachment.Brand}}</span></a>
</div>
